import { Collection, Model } from '..'
import Enhancer from '../Enhancer'

class Tag extends Model {
    constructor(json, ...args) {
        super(...args)
        this.apiBase = 'tags'
        this._model = json
        return new Proxy(this, Enhancer)
    }

    get id() {
        return this._model.id ? this._model.id : 'all'
    }

    get name() {
        return this._model.name_token
    }
}

class Tags extends Collection {
    constructor(...args) {
        super(...args)
        this.apiBase = 'tags'
    }

    push(item) {
        super.push(new Tag(item))
    }

    get groups() {
        let result = []
        this.items.forEach((item) => {
            if (item.restaurant_count > 0 && !!item.tag_group?.id) {
                if (
                    !result.find((group) =>
                        group.tag_group ? group.tag_group.id === item.tag_group.id : false
                    )
                ) {
                    /** if the given item's tag_group still doesn't exist then create it */
                    result.push({
                        tag_group: item.tag_group
                            ? item.tag_group
                            : {
                                  id: 0,
                                  name_token: 'NO_ID',
                              },
                        items: [],
                    })
                }
                /** avoid empty categories */
                result
                    .find((group) =>
                        item.tag_group
                            ? group.tag_group.id === item.tag_group.id
                            : group.tag_group.id === 0
                    )
                    .items.push(item)
            }
        })
        result.forEach((_, index) => {
            result[index].items.sort((a, b) =>
                a.name_token?.toLowerCase() > b.name_token?.toLowerCase()
                    ? 1
                    : a.name_token?.toLowerCase() === b.name_token?.toLowerCase()
                    ? 0
                    : -1
            )
        })
        return result.sort((a, b) => a.tag_group.id - b.tag_group.id)
    }

    fetch() {
        return super.fetch({})
    }
}

export { Tags, Tag }
